import React, {useState, useCallback} from 'react'
import {Search} from '@mdsol/onex-design'
import {useDispatch, useSelector} from 'react-redux'
import {diagnosticsAC} from 'redux/diagnostics/diagnostics.duck'
import {select_gridSession_filters_searchQuery} from 'redux/diagnostics/selectors'

const GridControl = () => {
  const dispatch = useDispatch()
  const defaultSearch = useSelector(select_gridSession_filters_searchQuery)
  const [searchQuery, setSearchQuery] = useState(defaultSearch)

  const handleSearchChange = useCallback((value: string) => {
    setSearchQuery(value)
  }, [])

  const handleSearchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      dispatch(diagnosticsAC.setSearchQuery(searchQuery))
      dispatch(diagnosticsAC.updatePaginationIndex(0))
      dispatch(diagnosticsAC.setShouldRunDiagnostic(true))
    }
  }

  const handleClear = () => {
    setSearchQuery('')
    dispatch(diagnosticsAC.setSearchQuery(''))
    dispatch(diagnosticsAC.setShouldRunDiagnostic(true))
  }

  return (
    <div className='onex-data-grid-control'>
      <div className='onex-data-grid-control__actions'>
        <Search
          placeholder='Search'
          showClearBtn
          dataTestId='diagnostics-search-field'
          value={searchQuery}
          onChange={handleSearchChange}
          onKeyPress={handleSearchKeyPress}
          onClear={handleClear}
        />
      </div>
    </div>
  )
}

export default GridControl
